<script setup>
import Recom from '@/components/neta/Recom.vue';
import Recomdoc from '@/components/neta/Recomdoc.vue';
</script>
<template>
<v-card>
  <v-tabs
    fixed-tabs
    v-model="tab"
    background-color="#FDF0F0"
    color="#E13533"
  >
    <v-tabs-slider color="#E13533"></v-tabs-slider>
    <v-tab>プレスリリース</v-tab>
    <v-tab>おすすめメディア</v-tab>
  </v-tabs>
  <v-tabs-items v-model="tab">
      <v-tab-item>
        <Recomdoc :therm="therm" :kind="kind" :keyword="keyword" :tag="tag" />
    </v-tab-item>
    <v-tab-item>
        <Recom :therm="therm" :kind="kind" :keyword="keyword" :tag="tag" />
    </v-tab-item>
  </v-tabs-items>
</v-card>
</template>
<script>
export default {
	props : ["therm","kind","keyword","tag"],
    data () {
      return {
        tab : null,
        conf_data : {},
        direction : "",
        signature : "",
      }
    },
    methods : {
        dialog_open : function(data){
            this.$refs.docdialog.open(data.query,data.mode);
        },
    },
    created : function(){
    },
  }
</script>
